import React from "react";
import { Box, Container } from "@mui/material";
import AppBarSection from "./components/main/AppBarSection";

const TrustCertificationPage: React.FC = () => {
    return (
        <Box sx={{ background: '#fff', minHeight: '100vh' }}>
            <AppBarSection />

            {/* 이미지 콘텐츠 */}
            <Container maxWidth="md">
                <Box
                    component="img"
                    src="/assets/trust_certification.jpg"
                    alt="다원트레이드 중고폰 안심거래 인증 기업"
                    sx={{
                        width: '100%',
                        height: 'auto',
                        display: 'block',
                    }}
                />
            </Container>
        </Box>
    );
};

export default TrustCertificationPage;
